import React from "react";
import { cn } from "@/lib/utils";

export interface StatusOption {
  status: string | number;
  text: string;
  color: string;
}

interface StatusCellProps {
  statuses: StatusOption[];
  currentStatus?: string | number;
  className?: string;
}

export const StatusCell: React.FC<StatusCellProps> = ({
  statuses,
  currentStatus,
  className,
}) => {
  if (currentStatus === undefined || currentStatus === null) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  const currentStatusOption = statuses.find((s) => s.status === currentStatus);

  if (!currentStatusOption) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  return (
    <div
      className={cn(
        "min-w-28 mx-auto w-fit px-4 py-3 rounded-lg border-2",
        currentStatusOption.color,
        className,
      )}
    >
      {currentStatusOption.text}
    </div>
  );
};
